import {GoogleAnalytics} from '../../../../application/analytics/googleAnalytics';

class ShopAnalytics extends GoogleAnalytics {
    _loadScript() {
        super._loadScript();
        this._loadOptimize();
    }

    sendShopPageEvent(name) {
        this._send('shop_page', name);
    }

    sendPageViewEvent(isAffiliateShop = false) {
        this.sendShopPageEvent(isAffiliateShop ? 'view-affiliated' : 'view-regular');
    }
}

export {ShopAnalytics};
